import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import theme from "../../../styles/theme.semantic";

const HorizontalList = styled.ul`
  width: 100%;
  position: ${props => props.position};
  left: ${props => props.left};

  li {
    display: ${props => props.display};
  }

  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575px) {
    text-align: ${props => props.xsTextAlign};
  }
`;

HorizontalList.propTypes = {
  display: PropTypes.string,
  spacing: PropTypes.string
};

HorizontalList.defaultProps = {
  display: "inline",
  spacing: theme.spacing.s
};

export default HorizontalList;
